<template>
  <section id="pricing" class="tw-bg-white tw-py-24">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-text-center tw-mb-16">
        <h2 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-leading-tight">
          Let's Build Your Event Strategy
        </h2>
        <p class="tw-text-lg tw-text-gray-600 tw-max-w-2xl tw-mx-auto">
          Customized solutions—no one-size-fits-all.
        </p>
      </div>

      <div class="tw-max-w-4xl tw-mx-auto">
        <!-- Pricing Highlight -->
        <div class="tw-text-center tw-mb-12">
          <div class="tw-inline-block">
            <p class="tw-text-lg md:tw-text-xl tw-font-medium tw-text-gray-600 tw-mb-2">Pricing starts from</p>
            <p class="tw-text-5xl md:tw-text-6xl tw-font-bold tw-text-primary-600 tw-mb-3">$999</p>
          </div>
        </div>

        <!-- Features List -->
        <div class="tw-space-y-3 tw-mb-10">
          <div class="tw-flex tw-items-center tw-p-4 tw-bg-gray-50 tw-rounded-xl hover:tw-bg-gray-100 tw-transition-colors">
            <div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="tw-text-gray-900 tw-font-medium">Setup & configuration</span>
          </div>

          <div class="tw-flex tw-items-center tw-p-4 tw-bg-gray-50 tw-rounded-xl hover:tw-bg-gray-100 tw-transition-colors">
            <div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="tw-text-gray-900 tw-font-medium">Integration support</span>
          </div>

          <div class="tw-flex tw-items-center tw-p-4 tw-bg-gray-50 tw-rounded-xl hover:tw-bg-gray-100 tw-transition-colors">
            <div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="tw-text-gray-900 tw-font-medium">Matching configuration</span>
          </div>

          <div class="tw-flex tw-items-center tw-p-4 tw-bg-gray-50 tw-rounded-xl hover:tw-bg-gray-100 tw-transition-colors">
            <div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="tw-text-gray-900 tw-font-medium">Live support</span>
          </div>

          <div class="tw-flex tw-items-center tw-p-4 tw-bg-gray-50 tw-rounded-xl hover:tw-bg-gray-100 tw-transition-colors">
            <div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
              <svg class="tw-w-5 tw-h-5 tw-text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="tw-text-gray-900 tw-font-medium">Analytics dashboard</span>
          </div>
        </div>

        <!-- CTA -->
        <div class="tw-text-center">
          <a
            :href="appConfig.calendlyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="tw-inline-block tw-bg-primary-600 tw-text-white tw-px-8 tw-py-4 tw-rounded-lg tw-text-lg tw-font-semibold hover:tw-bg-primary-700 tw-transition-colors tw-shadow-md hover:tw-shadow-lg"
          >
            Get a Custom Quote – Schedule a Call
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>
